var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"can",rawName:"v-can:[createPermission]",arg:_vm.createPermission}]},[_c('v-btn',{attrs:{"to":"/faqs/create","color":"accent"}},[_c('v-icon',[_vm._v("mdi-plus")]),_vm._v(" إنشاء سؤال جديد ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }